import { render, staticRenderFns } from "./group-chat.svg?vue&type=template&id=cffcd6d2"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports